// Copyright © 2021 Move Closer
import { TileSize } from './Tile.contracts';
/**
 * Registry that binds the `TileSize` with the applicable CSS class.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const tileSizeClassRegistry = {
    [TileSize.XL]: '--size-xl',
    [TileSize.L]: '--size-l',
    [TileSize.S]: '--size-s'
};
/**
 * Maximum image widths for different tile sizes and screen types.
 */
export const tileImageMaxWidths = {
    mobile: 768,
    desktop: {
        [TileSize.XL]: 1024,
        [TileSize.L]: 640,
        [TileSize.S]: 320 // 300
    }
};
/**
 * Title length thresholds for determining if title is "long"
 */
export const titleLengthThresholds = {
    [TileSize.XL]: 60,
    [TileSize.L]: 50,
    [TileSize.S]: 70
};
/**
 * Title lines estimation thresholds
 */
export const titleLinesThresholds = {
    short: 40,
    medium: 80
};
/**
 * Maximum lines configuration for different tile sizes
 */
export const titleMaxLinesConfig = {
    [TileSize.XL]: { short: 2, long: 3 },
    [TileSize.L]: { short: 3, long: 4 },
    [TileSize.S]: { short: 3, long: 4 }
};
/**
 * Slider transition timing configuration
 */
export const sliderConfig = {
    backgroundChangeDelay: 400
};
